// extracted by mini-css-extract-plugin
export var errorsContainer = "_vk-1";
export var link = "_vk-0";